import { useEffect, useRef } from "react";
import { trackEvent } from "./analytics.ts";

/** One "spot-view" event per (slug, view) pair; no event on the plain map. Umami Events ranks by `spot`. */
export function useSpotViewEvent(slug: string | undefined, view: "2d" | "3d"): void {
  const last = useRef<string | null>(null);
  useEffect(() => {
    if (!slug) {
      last.current = null;
      return;
    }
    const key = `${slug}|${view}`;
    if (last.current === key) return;
    last.current = key;
    trackEvent("spot-view", { spot: slug, view });
  }, [slug, view]);
}
